import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    paper: {
      marginTop: 10,
      minHeight: 396,
      width: '100%',
      '& .MuiDataGrid-root': {
        border: 'none',
      },
      '& .MuiDataGrid-footer': {
        backgroundColor: variables.white,
      },
    },
    contentMargin: {
      marginTop: 20,
    },
    accordionDetails: {
      flexDirection: 'column',
      padding: 0,
      border: 'none',
    },
    rulesTitlePanel: {
      margin: '40px 0px 20px 0',
      paddingLeft: 15,
      paddingRight: 10,
    },
    rulesTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: variables.richBlack,
    },
    button: {
      borderRadius: 25,
      padding: '10px 20px 10px 20px',
    },
    margin: {
      marginTop: 20,
    },
  }),
);
